function animateLogo(){
    const elLogoWrapper = document.querySelector('.aw-logo-wrapper');
    if( !elLogoWrapper || !anime ) return;

    // TO DO
}

document.addEventListener('DOMContentLoaded', animateLogo);